import { useLocation, useParams } from "react-router";

/**
 * Purpose is to fetch projectId or propertyId from URL search params
 * @returns {Object} Always spaceId, conditionally projectId or propertyId
 */
const useResourceIds = () => {
  const {
    projectId: routeProjectId,
    propertyId: routePropertyId,
    spaceId,
  } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const queryProjectId = query.get("projectId");
  const queryPropertyId = query.get("propertyId");

  return {
    projectId: routeProjectId || queryProjectId || null,
    propertyId: routePropertyId || queryPropertyId || null,
    spaceId,
  };
};

export default useResourceIds;
